import { jsx as _jsx } from "react/jsx-runtime";
import { createBrowserRouter } from "react-router";
import { DefaultLayout } from "@/layouts/DefaultLayout";
import { routes } from "@/router/routes";
import { RoutesList } from "./routesList";
export var getRouter = function () {
    return createBrowserRouter([
        {
            path: RoutesList.Root,
            element: _jsx(DefaultLayout, {}),
            children: routes,
        },
    ]);
};
